export const GOOGLE_MAPS_DEVELOPMENT_API_KEY =
  'AIzaSyDBJpILl03d9v678BEQVPjLfNNj56akcVU';
export const GOOGLE_MAPS_STAGING_API_KEY =
  'AIzaSyBoDpCo2zZcuVUNPlhkqR316DMjFBlR-ZU';
export const GOOGLE_MAPS_PRODUCTION_API_KEY =
  'AIzaSyCd-4jOoG2QSQzsvc4_ldpEBzU14QYV3-Y';
